import {environment} from '../../../environments/environment';

export const authConfig = {
  Cognito: {
    userPoolId: environment.auth.userPoolId,
    userPoolClientId: environment.auth.userPoolWebClientId,
  },
  LocationService: {
    region: environment.auth.region,
  }
};
